import { UseFormReturn, useWatch } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { codeToFlag } from "@/features/regions/utils/code-to-flag";
import { PaymentPageWizardData } from "./wizard-form";

export default function StepPageDetails({
  form,
}: {
  form: UseFormReturn<PaymentPageWizardData>;
}) {
  const regionCode = useWatch({ control: form.control, name: "region" });

  return (
    <div className="space-y-6">
      <div className="rounded-md bg-gray-50 px-3 py-2 text-xs text-gray-500">
        Region: {codeToFlag(regionCode)} {regionCode?.toUpperCase() || "—"}
      </div>

      <div className="grid grid-cols-2 gap-4">
        <FormField
          control={form.control}
          name="slug"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Slug <span className="text-red-500">*</span>
              </FormLabel>
              <FormControl>
                <Input
                  placeholder="e.g. therapy-4-session"
                  {...field}
                  onChange={(e) =>
                    field.onChange(e.target.value.toLowerCase())
                  }
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="page_id"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Page ID <span className="text-red-500">*</span>
              </FormLabel>
              <FormControl>
                <Input placeholder="Page ID" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="page_title"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Page Title <span className="text-red-500">*</span>
              </FormLabel>
              <FormControl>
                <Input placeholder="Page title" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="status"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Status</FormLabel>
              <Select value={field.value} onValueChange={field.onChange}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Status" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="ACTIVE">Active</SelectItem>
                  <SelectItem value="INACTIVE">Inactive</SelectItem>
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="layout_variant"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Page Design</FormLabel>
              <Select
                value={field.value ?? "classic"}
                onValueChange={field.onChange}
              >
                <FormControl>
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="classic">Classic (default)</SelectItem>
                  <SelectItem value="v2">New design</SelectItem>
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
